import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import NewsFeed from "./components/NewsFeed";
import Timeline from "./components/Timeline";
import Specials from "./components/Specials";
import Categories from "./components/Categories";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { brand, faqs } from "@/mocks/home";

function buildJsonLd() {
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: brand.name,
    url: "https://okvch.cn/",
    slogan: brand.slogan,
    description: brand.desc,
  };
  const web = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: brand.name,
    url: "https://okvch.cn/",
    inLanguage: "zh-CN",
    description: brand.desc,
  };
  const page = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: `${brand.name} - 热点事件全记录`,
    url: "https://okvch.cn/",
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: brand.name },
  };
  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return [org, web, page, faq].map((s) => JSON.stringify(s));
}

export default function Home() {
  useEffect(() => {
    document.title = "爆料网 - 热点事件全记录|真相揭秘|内幕合集|深度解析";
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div id="top" className="bg-[#faf5ee] min-h-screen">
      {buildJsonLd().map((s, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: s }} />
      ))}

      <Navbar />

      <main>
        <Hero />
        <div className="reveal">
          <HotRank />
        </div>
        <div className="reveal">
          <NewsFeed />
        </div>
        <div className="reveal">
          <Timeline />
        </div>
        <div className="reveal">
          <Specials />
        </div>
        <div className="reveal">
          <Categories />
        </div>
        <div className="reveal">
          <Faq />
        </div>
        <div className="reveal">
          <About />
        </div>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}